export enum Theme {
  LightMode = 'LightMode',
  DarkMode = 'DarkMode',
}

export type PropsWithTheme<P> = P & { theme?: Theme };
